export default __webpack_public_path__ + "static/media/boxtype17.f6bea2bf.JPG";